export default "__VITE_ASSET__C_o2cNgq__"